export default __webpack_public_path__ + "static/bennettLiz-1dd230251e59ff9c02dc9fb30b2dcbb6.svg";